import { IFactoid } from '../../types/builder';
import { IApplicationState } from '../../types/redux';

export const selectFactoids = (state: IApplicationState): IFactoid[] => {
  const { foundationYear, constructTotalCount, lastYearConstructCount } = state.builderCard;

  return [
    {
      count: foundationYear,
      text: 'год\nоснования',
    },
    {
      count: constructTotalCount,
      text: 'домов построено\nза время работы',
    },
    {
      count: lastYearConstructCount,
      text: 'домов построено\nв прошлом году',
    },
  ].filter(item => item.count);
};
